
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|79|9)|021|13|290|422|479|617|720|734|8|945|982)|2(133|146|266|479|518|553|619|754|794|840)|5(96[36]|3(09|78|79)|6(37|4|81|91)|406|511|583|726|854)|6(4(19|48|94)|(53|56|61)8|02|034|370|732|827|86)|1(97(|5)|7(15|33|89)|04|153|58|657)|8(4(18|30|6)|(09|15|55|73)4|(2|92|99)2|025|278|63|666|877)|7((05|3|99)8|(20|65|79|83)3|195|322|531|547|632)|3(5(05|35|91)|7(21|74|81)|9(18|2|43)|[02]30|14|266|334|37|438|443|697)|9(9(|14|98)|046|166|280|4|457|614|650))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
